import type { ContentCategory, RawCategory } from '../types';

export const transformCategories = (rawCategories: RawCategory[]): ContentCategory[] => {
  const categories: ContentCategory[] = [];

  rawCategories?.forEach((rawCategory) => {
    if (rawCategory.stages.length < 1) return;

    const sortedStages = [...rawCategory.stages].sort((a, b) => a.sorting - b.sorting);

    categories.push({
      alias: rawCategory.alias,
      id: rawCategory.id,
      name: rawCategory.name,
      pageIds: sortedStages.map((stage) => stage.id),
      showon: sortedStages.map((stage) => stage?.meta?.showon as number),
      sorting: rawCategory.sorting as number,
    });
  });

  return [...categories].sort((a, b) => a.sorting - b.sorting);
};
